import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * shadcn/ui's class merger, and the reason the primitives can take a
 * `className` that actually wins.
 *
 * `clsx` flattens conditionals; `tailwind-merge` then resolves the collisions
 * Tailwind cannot — `p-4` and `p-3` in the same string used to leave the winner
 * up to stylesheet order, which is how a `<Card padding="p-3">` quietly kept
 * its `p-4`. Every primitive in `src/components/ui/` composes its variants
 * through this.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
